<template>
    <div id="app">
        <!-- SESSION IS NOT OPENED -->
        <div class="c2c-call">
          <!-- ONLINE -->
          <div v-if="data.availability  == 'available'">
            <div class="c2c-call-available">
                <img src="../assets/click-on-call.png">
            </div>
            <div class="c2c-call-available-selection">

                <span class="c2c-call-triangle">

                </span>

                <!-- USER LOGGED IN -->
                <div v-if="data.CustomerId">
                    <v-select id="c2c-call-consultant-number"
                              :options="data.phones"
                              :searchable=false
                              :taggable=false
                              :value="selectedCustomerPhone"
                              v-model="selectedCustomerPhone">
                    </v-select>
                </div>

                <!-- USER NOT LOGGED IN -->
                <div class="c2c-call-select-number" v-else>
                    <input type="text" v-model="selectedCustomerPhone.value" :placeholder="t('Indtast dit telefonnummer')">
                </div>

                <!-- INPUTS AND BUTTONS TO MAKE A C2C -->
                <div class="c2c-call-enter-pin">
                    <input type="password" v-model="consultant.CustomerPin" :placeholder="t('Indtast din 4-cifret PIN-kode')">
                </div>
                <!-- <div class="c2c-call-coupon-number">
                    <label>Hvis du har et kuponnummer, kan du indtaste det her.</label>
                    <input type="text" placeholder="Kuponnummer" v-model="couponCode">
                </div> -->

                <div class="c2c-call-buttons">
                    <!-- <button class="c2c-cancel-btn" @click="close()">CANCEL</button> -->
                    <button class="c2c-call-btn"
                            :disabled="callButtonDisable"
                            @click="makeCall()">
                          {{t('Ring mig op')}}
                    </button>
                </div>

                <div class="c2c-call-message">
                  <div>{{t('Ved klik på "Ring mig op" ringes du')}} </div>
                  <div>{{t('op indenfor 10-15 sekunder af')}}</div>
                  <div>{{t('konsulenten')}} {{t('fra')}} <strong>{{t('tlf.')}}{{t('35 15 61 73')}}</strong></div>
                </div>

                <!-- LINK TO REGISTRATION PAGE IF USER NOT LOGGED IN -->
                <div class="c2c-call-no-account" v-if="!data.CustomerId">
                     {{t('Er du ikke bruger')}} <a href="/opret-bruger/" @click="opretDigHerGoogleAnalytics">{{t('opret dig her')}}</a>.
                </div>

                <div v-if="errorMsg" class="c2c-error">
                    {{errorMsg}}
                </div>
                <div class="c2c-call-consultant-call-data">
                  <div class="price-per-minute">{{data.pricePerMinute}} {{t('kr/minut')}} - {{t('minimum')}} {{data.minimumDuration}} {{t('minutter')}}</div>
                  <div class="consultant-rating">
                    <star-rating  :inline="true"
                                  :star-size="20"
                                  :read-only="true"
                                  :show-rating="false"
                                  v-model="data.ratings">
                    </star-rating>
                    ({{data.ratingsNum}})
                  </div>
                </div>
            </div>
          </div>

          <!-- BUSY -->
          <div class="c2c-call-busy" v-else-if="data.availability  == 'busy'">
            <div class="c2c-call-busy-top">
                 <img src="../assets/click-on-call-red.png">
                 <span class="c2c-call-triangle"></span>
            </div>
            <div class="c2c-call-busy-bottom">
                <div class="c2c-call-busy-message">
                      <!-- {{t('Jeg er optaget lige nu.')}}<br/>{{t('Vil du have besked på sms når jeg er ledig igen?')}} -->
                      {{t('Skriv dit telefonnummer og PIN-kode for at stille dig i kø')}}
                      <button @click="displayQueueInfo" class="queue-info">i</button>
                      <!-- USER LOGGED IN -->
                      <div v-if="data.CustomerId">
                          <v-select id="c2c-call-consultant-number"
                                    :options="data.phones"
                                    :searchable=false
                                    :taggable=false
                                    :value="selectedCustomerPhone"
                                    v-model="selectedCustomerPhone">
                          </v-select>
                      </div>

                      <!-- USER NOT LOGGED IN -->
                        <div class="c2c-call-select-number" v-else>
                            <input type="text" v-model="selectedCustomerPhone.value" :placeholder="t('Indtast dit telefonnummer')">
                        </div>
                        <div class="c2c-call-enter-pin">
                            <input type="password" v-model="consultant.CustomerPin" :placeholder="t('Indtast din 4-cifret PIN-kode')">
                        </div>
                </div>
                <div class="c2c-call-buttons">
                  <button class="c2c-cancel-btn" @click="makeCall()">{{t('JA TAK!')}}</button>
                  <button class="c2c-cancel-btn" @click="close()">{{t('NEJ TAK!')}}</button>
                </div>
             </div>
          </div>

          <!-- OFFLINE -->
          <div class="c2c-call-offline" v-else>
              <div class="c2c-call-offline-top">
                   <img src="../assets/click-on-call-grey.png">
                   <span class="c2c-call-triangle"></span>
              </div>
              <div v-if="!callButtonDisable" class="c2c-call-offline-bottom">
                <div class="c2c-call-offline-title">
                  {{t('Bed mig komme online')}}
                </div>
                <div class="c2c-call-offline-message">
                      {{t('Skriv dit telefonnummer og PIN-kode og send anmodning')}}
                      <button @click="displayOnlineRequestInfo" class="queue-info">i</button>
                      <!-- USER LOGGED IN -->
                      <div v-if="data.CustomerId">
                          <v-select id="c2c-call-consultant-number"
                                    :options="data.phones"
                                    :searchable=false
                                    :taggable=false
                                    :value="selectedCustomerPhone"
                                    v-model="selectedCustomerPhone">
                          </v-select>
                      </div>

                      <!-- USER NOT LOGGED IN -->
                      <div class="c2c-call-select-number" v-else>
                          <input type="text" v-model="selectedCustomerPhone.value" :placeholder="t('Indtast dit telefonnummer')">
                      </div>
                      <div class="c2c-call-enter-pin">
                          <input type="password" v-model="consultant.CustomerPin" :placeholder="t('Indtast din 4-cifret PIN-kode')">
                      </div>
                </div>
                <div v-if="errorMsg" class="c2c-error">
                    {{errorMsg}}
                </div>
                <div class="c2c-call-buttons">
                    <button :disabled="loading" class="c2c-cancel-btn" @click="setOnlineRequest()">{{t('JA TAK!')}}</button>
                    <button :disabled="loading" class="c2c-cancel-btn" @click="close()">{{t('NEJ TAK!')}}</button>
                </div>
                <spinner :status="loading" :size="60"></spinner>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
    // IMPORTS
    import axios from 'axios'
    import vSelect from 'vue-select'
    import VueStarRating from 'vue-star-rating'
    import Spinner from './Spinner'

    // COMPONENT DATA
    export default {

        name: 'C2cModal',

        // CONSULTANT/ CUSTOMER DATA
        props:{
                data: {type:Object},
                serverUrl: {type: String}
            },

        components: {
            'v-select': vSelect,
            'star-rating': VueStarRating,
            'spinner': Spinner
        },

        // CUSTOM COMPONENT DATA
        data () {
            return {
                consultant: {
                    CustomerPin: '',
                    ClairvoyantId: this.data.ClairvoyantId
                },
                customer: {
                    CustomerId: this.data.CustomerId
                },
                couponCode:null,
                callButtonDisable:false,
                canCall:true,
                loading:false,
                selectedCustomerPhone: {},
                errorMsg: ''
            }
        },

        // INITIALIZATIONS WHEN COMPONENT RENDERS
        mounted() {
            if (window.k24CustomerData) {
              this.customer = window.k24CustomerData;
            }
            else {
              this.customer = null;
            }
            if(this.customer) {
              this.data.phones = this.customer.phones;
              this.data.CustomerId = this.customer.id;
              this.selectedCustomerPhone = this.customer.phones[0];
            }
            if (typeof window.canCall !== 'undefined') {
                this.canCall = window.canCall;
            }
        },

        // METHODS ON EVENTS
        methods: {
            displayQueueInfo() {
                var registerPage = '/opret-bruger/';
                if (window.locale !== 'da_DK') {
                    registerPage = '/oprett-bruker/';
                }
                let queueInfo = `
                    Køfunktionen
                    Når du kommer i kø og det er din tur, vil du modtage en <b>sms 1 - 5 minutter</b> før du ringes op og din samtale starter med konsulenten. Svarer du ikke på opkaldet mister du din plads i køen.
                    Der angives en estimeret ca. ventetid. Dvs ventetiden kan være kortere eller længere end angivet. I visse situationer kan siden angive 0 minutter uden at konsulenten er ledig endnu.
                    Du skal have en konto hos os for at benytte denne funktion.
                `;

                alert(queueInfo);
            },

            displayOnlineRequestInfo () {
              var registerPage = '/opret-bruger/';
                if (window.locale !== 'da_DK') {
                    registerPage = '/oprett-bruker/';
                }

                let onlineRequestInfo = `
                  Med bed mig komme online, har du mulighed for at konsulenten logger på specielt til dig.
                  Du vil få besked indenfor 30 minutter om konsulenten kan / eller ikke kan dette.
                  Herefter udløber linket.
                  Du skal have en konto hos os for at benytte denne funktion.
                  Mvh. Klarsyn24.dk`;

                if(window.locale !== 'da_DK') {
                  onlineRequestInfo = `
                  Med be meg om å komme online, har du muligheten for konsulenten logger på spesielt for deg.
                  Du vil bli varslet innen 30 minutter om konsulenten kan / eller ikke kan gjøre dette.
                  Da utløper lenken.
                  Vennlig hilsen Klarsyn24.no`;
                }

                alert(onlineRequestInfo);
            },

            /**
             * Initializes a consulant session
             * @return {[object]} [phonecall data]
             */
            makeCall () {
                this.callButtonDisable = true;
                this.googleAnalyticsEvent({
                  eventCategory: 'konsulent',
                  eventAction: 'konsulent-ring-ledig-ring-mig-op',
                  eventLabel: this.data.name
                });

                if (!this.canCall) {
                  window.location.href = '/customer-info/';
                  return false;
                }

                if (this.data.queueBlocked) {
                  this.callButtonDisable = false;
                  alert('Denne konsulent tager ikke andre kunder i køen lige nu, prøv igen lidt senere');
                  return false;
                }
                if (this.data.previousCustomers >= 6) {
                  this.callButtonDisable = false;
                  alert('Denne konsulents kø er i øjeblikket fuld, prøv lidt senere');
                  return false;
                }

                let postData = this.consultant;

                postData['CustomerPhone'] = this.selectedCustomerPhone.value;

                // if(this.couponCode && this.couponCode != '') {
                //   // if(!this.data.CustomerId) {
                //   //   this.errorMsg = "You have to be logged in to use a coupon";
                //   //   return false;
                //   // }

                //   postData['couponCode'] = this.couponCode;

                //   var url = this.serverUrl'c2c/coupon/check';

                //   axios({
                //     method : 'post',
                //     url    : url,
                //     data   : postData,
                //   })
                //   .then((response) => {
                //       console.log(response.data);
                //       if (response.data.status == 'error') {
                //           this.errorMsg = response.data.message;
                //       }
                //       else {
                //           this.initiateSession(postData);
                //       }
                //   })
                //   .catch((error) => {
                //     console.log(error);
                //   })
                // }
                // else {
                // }
                  this.initiateSession(postData);
            },

            initiateSession(postData) {
              var url      = this.serverUrl+'c2c/session_start';
              axios({
                  method : 'post',
                  url    : url,
                  data   : postData,
                })
                .then((response) => {
                    console.log(response.data);
                    if (response.data) {
                      if (!response.data.success) {
                          if (response.data.error == 'Gateway error') {
                            this.$emit('errorGateway', {redirectionLink: response.data.redirection_link, customerData: response.data.customer_data, errorType: 'gateway'} );
                          }
                          else if (response.data.error == 'Expired CC') {
                            this.$emit('errorGateway', {redirectionLink: response.data.redirection_link, customerData: response.data.customer_data, errorType: 'expiredCard'} );
                          }
                          else {
                            this.errorMsg = response.data.error;
                          }
                      }
                      else {
                        if (!this.customer) {
                          this.customer = {
                            phones: [
                              this.selectedCustomerPhone
                            ]
                          };
                          this.data.CustomerId = response.data.wpId;
                        }

                        if (response.data.consultant_queue) {
                          if (response.data.consultant_queue.status == 'success') {
                            this.customer.id = response.data.consultant_queue.queue.customer_data.wp_id,
                            this.$emit('customerEnqueued', {customer: this.customer} );
                          }
                          else if(response.data.consultant_queue.status == 'error' && response.data.consultant_queue.error_code == 'CQ001') {
                            alert('Du står allerede i kø');
                          }
                        }
                        else {
                          this.customer.id = response.data.wpId,
                          this.$emit('startCall', {call_id: response.data.call_id, customer: this.customer} );
                        }
                      }
                    }
                    this.callButtonDisable = false;
                })
                .catch((error) => {
                  console.log(error);
                })
            },

            sendSms() {
              this.googleAnalyticsEvent({
                  eventCategory: 'konsulent',
                  eventAction: 'konsulent-ring-optaget-sms-ja',
                  eventLabel: this.data.name
              });
              var url = this.serverUrl+'consultant_availability/sms';
              let postData = {
                consultant_id : this.data.ClairvoyantId,
                customer_id   : this.data.CustomerId,
                customer_phone: this.selectedCustomerPhone.value
              }
              console.log(postData);

              axios({
                method: 'post',
                url   : url,
                data  : postData
              })
              .then((response) => {
                this.$emit('exit', this.customer);
              })
            },

            setOnlineRequest() {
              this.loading = true;
              if (!this.canCall) {
                window.location.href = '/customer-info/';
                return false;
              }

              let postData = this.consultant;

              postData['CustomerPhone'] = this.selectedCustomerPhone.value;

              var url = this.serverUrl+'online_request/set';
              axios({
                  method : 'post',
                  url    : url,
                  data   : postData,
                })
                .then((response) => {
                    if (response.data) {
                        if (!response.data.success || response.data.error) {
                            if (response.data.error == 'Gateway error') {
                              this.$emit('errorGateway', {redirectionLink: response.data.redirection_link, customerData: response.data.customer_data, errorType: 'gateway'} );
                            }
                            else if (response.data.error == 'Expired CC') {
                              this.$emit('errorGateway', {redirectionLink: response.data.redirection_link, customerData: response.data.customer_data, errorType: 'expiredCard'} );
                            }
                            else {
                              this.errorMsg = response.data.error;
                            }
                        }
                        else {
                          if (response.data.online_request) {
                            this.$emit('exit', {customer: this.customer, sendSms: false});
                          }
                          else {
                            console.log('error');
                          }
                        }
                    }
                    this.loading = false;
                })
                .catch((error) => {
                  console.log(error);
                })
            },

            close () {
                this.googleAnalyticsEvent({
                  eventCategory: 'konsulent',
                  eventAction: 'konsulent-ring-optaget-sms-nej',
                  eventLabel: this.data.name
                });
                this.$emit('exit', this.customer);
            },

            opretDigHerGoogleAnalytics() {
              this.googleAnalyticsEvent({
                eventCategory: 'konsulent',
                eventAction: 'konsulent-ring-ledig-opret-dig-her',
                eventLabel: this.data.name
              });
            }
        }

    }
</script>

<style lang="css">

.c2c-call {
   width: 100%;
   max-width: 100%;
   background-color: #f1f1f1;
   position: absolute;
   top: 64%;
   transform: translateY(-50px);
   z-index: 2;
   border: 1px solid #707070;
   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
}

.c2c-in-session {
  width: 100%;
  max-width: 100%;
  background-color: #585857;
  position: absolute;
  font-size: 14px;
  top: 67%;
  transform: translateY(-50px);
  z-index: 2;
  color: #ffffff;
}

.c2c-failed-session {
  width: 100%;
  max-width: 100%;
  background-color: #e04557;
  position: absolute;
  top: 67%;
  transform: translateY(-50px);
  z-index: 2;
  color: #ffffff;
}

.c2c-failed-session h2,
.c2c-in-session h2 {
  text-align: center;
  font-size: 24px;
  color: #ffffff;
  font-weight: 700;
}

.c2c-in-session-text {
  width: 70%;
  margin: 0 auto;
}
.c2c-in-session-text div {
  text-align: center;
}

.c2c-call-available{
   height: 100px;
   background-color: #36BC92;
   color: white;
   position: relative;
}

.c2c-call-available img{
   margin: 0 auto;
   position: absolute;
   top: 12px;
   left: 0;
   right: 0;
}


.c2c-call-available-selection{
    padding: 20px;
    position: relative;
    background: #f1f1f1;
    width: 100%;
    z-index: 1;
}


.c2c-call-triangle{
   margin: 0 auto;
   width: 0;
   height: 0;
   border-style: solid;
   border-width: 0 20px 22px 20px;
   border-color: transparent transparent #ffffff transparent;
   position: absolute;
   top: -22px;
   left: 0;
   right: 0;
}


.c2c-call-available-selection .dropdown{
   width: 186px;
   height: 25px;
   background: #fff;
   margin: 0 auto;
}

.c2c-call-select-number select{
  display: block;
  width: 84%;
  height: 40px;
  color: #707070;
  font-size: 16px;
  text-align: center;
  padding: 0;
  margin: 0 auto;
  margin-top: 5px;
}

.c2c-call-select-number input{
  display: block;
  width: 84%;
  height: 36px;
  font-size: 16px;
  text-align: center;
  padding: 0;
  margin: 0 auto;
  margin-top: 5px;
  border: 1px solid #cccccc;
}

.c2c-call-enter-pin{
   margin-top: 6px;
   margin-bottom: 20px;
}

.c2c-call-enter-pin input{
   width: 186px;
   height: 36px;
   margin: 0 auto;
   text-align: center;
   padding: 0px;
   display: block;
}


.c2c-call-coupon-number{
   margin-top: 10px;
}

.c2c-call-coupon-number label{
   display: block;
   font-size: 11px;
   text-align: center;
   margin: 5px auto;
}

.c2c-call-coupon-number input{
   display: block;
   width: 84%;
   height: 36px;
   text-align: center;
   padding: 0;
   margin: 0 auto;
   margin-bottom: 20px;
}

.c2c-call-buttons{
    text-align: center;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    display: flex;
}

.c2c-call-buttons button {
  background: transparent;
  color: #00c18d;
  opacity: .8;
  border-bottom: 2px solid #48cfae;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  width: auto;
  font-size: 22px;
  font-weight: 700;
}

button.queue-info {
  display: inline-block;
  border-radius: 50%;
  width: 7%;
  font-size: 20px;
  background-color: #32cda3;
  text-align: center;
}

.c2c-call-buttons button:hover{
   cursor: pointer;
}

.c2c-call-buttons button:disabled,
.c2c-call-buttons button[disabled]{
   cursor: wait;
   opacity: 0.2;
}

.c2c-cancel-btn{
   float: left;
}

.c2c-call-btn{
   float: right;
}


.c2c-call-no-account{
    font-size: 16px;
    margin-top: 15px;
    text-align: center;
    color: #676767;
    padding-bottom: 20px;
}

.c2c-call-no-account a {
    color: #695bf6;
    text-decoration: none;
}

.c2c-call-message {
   margin: 20px 0;
}
.c2c-call-message div {
  text-align: center;
  font-size: 16px;
  color: #676767;
}

#c2c-call-consultant-number{
   height: 40px !important;
   font-size: 14px;
   font-weight: 300;
   text-align: center;
}


/* Busy */

.c2c-call-busy-top{
  height: 120px;
  background-color: #e04557;
  color: white;
  position: relative;
}

.c2c-call-busy-top img{
  display: block;
   margin: 0 auto;
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
}


.c2c-call-busy .c2c-call-triangle{
  top: unset;
  bottom: 0px;
}

.c2c-call-busy-bottom{
   background: #fff;
   text-align: center;
   padding-top: 25px;
   padding-bottom: 30px;
}

.c2c-call-busy-message{
  color: #707070;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
  padding-bottom: 25px;
}

/* Offline */

.c2c-call-offline-top{
  height: 120px;
  background-color: #a5a5a5;;
  color: white;
  position: relative;
}

.c2c-call-offline-top img{
  display: block;
   margin: 0 auto;
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
}


.c2c-call-offline .c2c-call-triangle{
  top: unset;
  bottom: 0px;
}

.c2c-call-offline-bottom{
   background: #fff;
   text-align: center;
   padding-top: 25px;
   padding-bottom: 30px;
}

.c2c-call-offline-message{
  font-size: 16px;
  line-height: 25px;
}


 @media only screen and (max-width: 991px) {

    .c2c-call-available-selection .dropdown {
      max-width: 100%;
    }

    .c2c-call-enter-pin input {
      max-width: 100%;
    }

    .c2c-call-message div {
      font-size: 13px;
    }

    .c2c-call-no-account {
      font-size: 13px;
    }
 }



.c2c-error {
    color: #de3838;
    font-size: 14px;
    text-align: center;
    padding-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/C2cCallButton.vue